module.exports = __webpack_public_path__ + "img/detail-popup.bae0ff75.png";